module.exports = __webpack_public_path__ + "static/media/IMG_20220411_151239_255-min.266605c1.jpg";